import React from 'react';
import { Box, Typography } from '@material-ui/core';

const SectionLabel = ({ children }) => (
  <Box
    className="rms-section-label"
    bgcolor="primary.main"
    color="#fff"
    px={1}
    py={0.25}
    display="inline-block"
    mb={1}>
    <Typography variant="caption" className="rms-section-label__text">
      {children}
    </Typography>
  </Box>
);

export default SectionLabel;
